<div [matTooltip]="getButtonTooltip() | transloco: { name: participantName() }">
	<button
		matIconButton
		class="btn-tertiary"
		[attr.aria-label]="getButtonTooltip() | transloco: { name: participantName() }"
		(click)="onClick()"
		[disabled]="disabled()"
		[matMenuTriggerFor]="showMenu() ? menu : null"
		#trigger="matMenuTrigger"
	>
		<mat-icon class="material-symbols-outlined" aria-hidden="true"> forward_to_inbox </mat-icon>
	</button>
</div>

<!-- Select email menu -->
<mat-menu #menu="matMenu" xPosition="after" yPosition="below">
	<div class="emails-menu">
		<p class="title-menu">
			{{ 'send_email.title_menu' | transloco }}
		</p>
		<span class="text-menu">{{ 'send_email.text_menu' | transloco }}</span>
		<mat-divider class="bottom"></mat-divider>
		<section class="bottom">
			@if (emails().length > 1) {
				@for (e of emails(); track e.id) {
					<button mat-menu-item (click)="selectAndSend(e.value ?? '')">
						<div class="email-info">
							<span>{{ e.value }}</span>
							<span class="remark">{{ e.remark }}</span>
							<span class="remark">{{
								e.preferred ? ('base.field.group.preferred_contact_type' | transloco) : ''
							}}</span>
						</div>
					</button>
				}
			} @else {
				{{ 'send_email.no_email' | transloco }}
			}
		</section>
	</div>
</mat-menu>
